// extracted by mini-css-extract-plugin
export default {"label":"S72A","disablePointerEvents":"_9qkV","buttonLabel":"hhTs","labelBox":"UU19","labelBoxInline":"TtLx","labelTitleContainer":"+5e3","withoutStartIcon":"+xFZ"};